import { noop } from 'app/shared/lib/noop';
import { Binding } from 'aurelia-framework';

/**
 * Forces Aurelia to keep a target (e.g. an input) in sync when a value converter translates a different input into the same output.
 */
export class SyncBindingBehavior {

    updateSource: Function = noop;

    bind(binding: Binding & any) {
        const defaultUpdateSource = this.updateSource = binding.updateSource;
        binding.updateSource = function updateSource(value: any) {

            // Check the old value of the source.
            const oldValue = this.sourceExpression.evaluate(this.source, this.lookupFunctions);

            // Run the default update source method.
            defaultUpdateSource.call(this, value);

            // Check the newly updated value of the source..
            const newValue = this.sourceExpression.evaluate(this.source, this.lookupFunctions)

            // If they are the same, where Aurelia would do nothing for preformance
            // and to prevent recursion, we force an update.
            if (oldValue === newValue) {
                this.updateTarget(String(newValue));
            }
        }
    }

    unbind(binding: Binding & any) {
        binding.updateSource = this.updateSource;
        this.updateSource = noop;
    }
}
